import { connect } from 'react-redux';
import LiveControlButtons from 'components/live/LiveControlButtons';

// windTurbine can be momentarily undefined during navigation between two
// turbines' detail pages - see components/dashboard/CardHeader.js's guard
// for the crash this caused. mapStateToProps runs on every store update.
const mapStateToProps = (state, ownProps) => ({
    turbineParams: state.turbineParams[ownProps.windTurbine && ownProps.windTurbine.id],
});

export default connect(mapStateToProps)(LiveControlButtons);
